import { render } from "./WithdrawalInfoCard.vue?vue&type=template&id=4e23b576&scoped=true"
import script from "./WithdrawalInfoCard.vue?vue&type=script&lang=js"
export * from "./WithdrawalInfoCard.vue?vue&type=script&lang=js"

import "./WithdrawalInfoCard.vue?vue&type=style&index=0&id=4e23b576&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e23b576"]])

export default __exports__